import {SalesAuditReportData} from "./sales-audit-report.data";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesAuditReportModel extends ReportModel<SalesAuditReportData> {
    constructor(injector: Injector) {
        super(injector, SalesAuditReportData);
    }

}
